module.exports = __webpack_public_path__ + "static/img/gh_9466731f8652_258 (1).eb6cca8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gh_9466731f8652_258 (1).jpg
// module id = EZF5
// module chunks = 36